export default 'exicube';
